import React from "react";
import EditContactForm from "../Components/Pages/EditContact/EditContactForm";

function EditContact() {
  return (
    <div className="p-9">
      <EditContactForm />
    </div>
  );
}

export default EditContact;